/* Embla product rails + fading announcement bar, matching the live behaviour */
(function () {
  'use strict';
  function initRails() {
    if (!window.EmblaCarousel) return;
    document.querySelectorAll('[data-embla-rail]').forEach(function (rail) {
      var node = rail.querySelector('[data-embla]');
      if (!node || node.dataset.ready) return;
      node.dataset.ready = '1';
      // live embla_options (goya-child inline): loop false, align start, inViewThreshold .3, dragFree false,
      // draggable/watchDrag true, slidesToScroll 1, containScroll trimSnaps. Its `speed: 12` is not an Embla v8
      // option and is ignored there, so the live rails run at the default duration 25 (measured ~700-780ms per
      // 320px step); the category carousel is the one live re-inits with loop: true.
      var embla = window.EmblaCarousel(node, {
        loop: rail.hasAttribute('data-embla-loop'), align: 'start', containScroll: 'trimSnaps', duration: 25,
        dragFree: false, watchDrag: true, slidesToScroll: 1, inViewThreshold: 0.3
      });
      var prev = rail.querySelector('[data-embla-prev]');
      var next = rail.querySelector('[data-embla-next]');
      if (prev) prev.addEventListener('click', function () { embla.scrollPrev(); });
      if (next) next.addEventListener('click', function () { embla.scrollNext(); });
      // live (goya-child branding carousel) never toggles [disabled]; arrows stay full black at both ends
    });
  }
  if (document.readyState !== 'loading') initRails();
  else document.addEventListener('DOMContentLoaded', initRails);
})();

/* ---------- hero fade slider: autoplay, infinite, pause on hover, dots ---------- */
(function () {
  'use strict';
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    if (slides.length < 2) return;
    var i = 0, timer = null, delay = Number(hero.dataset.autoplay) || 4000;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        s.setAttribute('aria-hidden', String(k !== i));
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        if (d.parentElement && d.parentElement.tagName === 'LI') { d.parentElement.classList.toggle('is-active', k === i); d.parentElement.classList.toggle('slick-active', k === i); }
        d.setAttribute('aria-selected', String(k === i));
      });
    }
    function start() { stop(); timer = setInterval(function () { show(i + 1); }, delay); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (d) { d.addEventListener('click', function () { show(Number(d.dataset.heroDot)); start(); }); });
    // live slick pauseOnHover: true on the top hero, false on the editorial banner instances
    if (!hero.hasAttribute('data-nopause')) {
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
    }
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  });
})();

/* ---------- centred Embla sliders (celebs, showcase): centre, infinite, autoplay ---------- */
(function () {
  'use strict';
  function init() {
    if (!window.EmblaCarousel) return;
    document.querySelectorAll('[data-embla-center]').forEach(function (node) {
      if (node.dataset.ready) return;
      node.dataset.ready = '1';
      var embla = window.EmblaCarousel(node, { loop: true, align: 'center', containScroll: false, dragFree: false });
      var timer = null;
      function start() { stop(); timer = setInterval(function () { embla.scrollNext(); }, 3500); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      node.addEventListener('mouseenter', stop);
      node.addEventListener('mouseleave', start);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
    });
    // PDP rails share the plain rail init
    document.querySelectorAll('.zp__rail [data-embla]').forEach(function (node) {
      if (node.dataset.ready) return;
      node.dataset.ready = '1';
      window.EmblaCarousel(node, { loop: false, align: 'start', containScroll: 'trimSnaps', slidesToScroll: 2 });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('zcrave:cards-added', init);
})();

/* ---------- BUY NOW: add, then straight to checkout ---------- */
document.addEventListener('click', async function (e) {
  var b = e.target.closest('[data-buy-now]');
  if (!b) return;
  var form = b.closest('form[data-atc-form]');
  if (!form) return;
  b.disabled = true;
  try {
    var res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }] })
    });
    if (res.ok) location.href = window.Shopify.routes.root + 'checkout';
    else b.disabled = false;
  } catch (err) { b.disabled = false; }
});
